// toastErrorMiddleware.ts
import { Middleware } from '@reduxjs/toolkit'

import { showToast } from '../components/Toasts'

export const errorMiddleware: Middleware = () => (next) => (action) => {
  if (action.type.endsWith('/rejected') && action.error?.message) {
    showToast.error(action.error.message)
  }

  return next(action)
}
